import type { Candado } from "@/lib/candados";
import { casaBool, casaIgual, casaTexto } from "@/lib/filtros/texto";

/** CLAVES_CANDADOS son los parámetros que admite el listado de candados (#247). */
export const CLAVES_CANDADOS = ["estado", "activo", "q"] as const;

/** FiltrosCandados es el objeto de filtros del listado de candados tal como viaja en la URL. */
export type FiltrosCandados = Partial<Record<(typeof CLAVES_CANDADOS)[number], string>>;

/**
 * filtrarCandados aplica los filtros en el navegador (modo sin red, D2). Debe dar el MISMO
 * resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosCandadosHTTP).
 */
export function filtrarCandados(filas: Candado[], filtros: FiltrosCandados): Candado[] {
  return filas.filter(
    (c) =>
      // `estado` (LIBRE/EN_USO) es la traducción publicada del booleano derivado (#243).
      casaIgual(filtros.estado, c.estado) &&
      casaBool(filtros.activo, c.activo) &&
      // `q` alcanza también la relación ACTIVA que la propia fila publica (#289): el
      // nombre de los puntos que el candado tiene bloqueados ahora y el código del equipo
      // de esos puntos (el equipo viaja DENTRO de cada punto: `Candado` no tiene equipo
      // propio). Un bloqueo retirado no llega en `puntos`, así que la ausencia sale sola.
      casaTexto(
        filtros.q,
        c.codigo_candado,
        c.descripcion,
        ...c.puntos.flatMap((p) => [p.nombre, p.codigo_equipo]),
      ),
  );
}
